export default __webpack_public_path__ + "static/tech-nation-1-7da9ff5f60bb9299fee157f3ea8658e5.png";